export default __webpack_public_path__ + "static/media/male-avatar.b6b0d3c0.jpeg";